import { render, staticRenderFns } from "./GenerateLinkModal.vue?vue&type=template&id=b12865d2&scoped=true&"
import script from "./GenerateLinkModal.vue?vue&type=script&lang=ts&"
export * from "./GenerateLinkModal.vue?vue&type=script&lang=ts&"
import style0 from "./GenerateLinkModal.vue?vue&type=style&index=0&id=b12865d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b12865d2",
  null
  
)

export default component.exports